import {
	Alert,
	AlertDescription,
	AlertIcon,
	AlertTitle,
	Button,
} from '@chakra-ui/react';
import { authService } from 'api/services/authService';
import { EMAIL_CONFIRMATION } from 'constant/messages';
import { NAVIGATE } from 'constant/navigation';
import AuthCentered from 'layouts/auth/types/Centered';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authActions } from 'store/auth';

const ConfirmEmail = () => {
	const [searchParams] = useSearchParams();
	const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
	const [message, setMessage] = useState('');
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		const token = searchParams.get('token');
		if (!token) {
			setStatus('error');
			setMessage(EMAIL_CONFIRMATION.TOKEN);
			return;
		}

		const verifyEmail = async () => {
			try {
				const response = await authService.confirmEmail(token);
				if (response.data.status === 'SUCCESS') {
					setStatus('success');
					setMessage(EMAIL_CONFIRMATION.SUCCESS);
					dispatch(authActions.setIsNewUser(true));
				} else {
					setStatus('error');
					setMessage(EMAIL_CONFIRMATION.ERROR);
				}
			} catch (error) {
				setStatus('error');
				setMessage(EMAIL_CONFIRMATION.ERROR);
			}
		};

		verifyEmail();
	}, [searchParams, dispatch, navigate]);

	return (
		<AuthCentered cardBottom='150px'>
			<Alert
				status={status}
				variant='subtle'
				minWidth={{ base: '100%', md: '600px' }}
				flexDirection='column'
				alignItems='center'
				justifyContent='center'
				textAlign='center'
				mt={6}
				py={6}
				borderRadius='lg'
			>
				<AlertIcon boxSize='40px' mr={0} />
				<AlertTitle mt={4} mb={1} fontSize='lg'>
					Confirmación de correo
				</AlertTitle>
				<AlertDescription my={status === 'loading' ? 10 : 2} maxWidth='sm'>
					{status === 'loading' ? 'Verificando correo electrónico...' : message}
				</AlertDescription>
				{status !== 'loading' && (
					<Button
						mt={4}
						variant='brand'
						onClick={() => navigate(NAVIGATE.HOME)}
					>
						Volver al inicio
					</Button>
				)}
			</Alert>
		</AuthCentered>
	);
};

export default ConfirmEmail;
